module.exports = __WEBPACK_EXTERNAL_MODULE_66__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 66
// module chunks = 66 67